import { Link, useLocation } from 'react-router-dom';
import { useVideoSends } from '../uploads/video-sends.js';

/**
 * A video on its way, followed off its lesson (board "Noa · Home while a video
 * sends", approved 16 October): a slim strip above the tabs, as the cart's is,
 * with the thumbnail and the bar, dimmed while the phone has it paused. Tap it
 * for the lesson. Not drawn on that lesson's own page, which shows the row.
 */
export function VideoSendStrip() {
  const { pathname } = useLocation();
  const send = useVideoSends().find((candidate) => candidate.state === 'sending');
  if (!send || pathname === send.href.split('?')[0]) return null;

  const share = send.totalBytes ? Math.round((send.sentBytes / send.totalBytes) * 100) : 0;
  return (
    <Link className="cart-strip video-strip" to={send.href} aria-label={`Video sending, ${share}%`}>
      <span className="strip-thumb" aria-hidden="true">
        {send.thumbnailUrl ? <img src={send.thumbnailUrl} alt="" /> : null}
      </span>
      <span className="send-bar" data-paused={send.paused ? '' : undefined} aria-hidden="true">
        <span style={{ width: `${share}%` }} />
      </span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
